// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

/**
 * String constants for command line processing.
 *
 * @public
 */
export const enum CommandLineConstants {
  /**
   * The name of the built-in action that serves suggestions for tab-completion
   */
  TabCompletionActionName = 'tab-complete'
}

export const SCOPING_PARAMETER_GROUP: unique symbol = Symbol('scoping');
